//const BASE_URL = "http://192.168.29.113:8080";
const BASE_URL = 'https://regapi.manoranjanmandal.in';

export const StudentAPI = {
  getAllStudents: `${BASE_URL}/student/getAllStudent`,
  getStudentById: (id) => `${BASE_URL}/student/getStudentById/${id}`,
  saveStudent: `${BASE_URL}/student/saveStudent`,
  updateStudent: (id) => `${BASE_URL}/student/updateStudent/${id}`,
  deleteStudent: (id) => `${BASE_URL}/student/deleteStudent/${id}`,
  downloadExcel: `${BASE_URL}/student/downloadExcel`,
  sendMail: (id) => `${BASE_URL}/student/sendMail/${id}`,
};

export const LoginAPI = {
  login: `${BASE_URL}/auth/login`,
}

/*
get all student = http://192.168.29.113:8080/student/getAllStudent

get student by ID = http://192.168.29.113:8080/student/getStudentById/:id

save student = http://192.168.29.113:8080/student/saveStudent

{
    "name": "स्वाती देश",
    "dob": "2010-03-25",
    "school": "नवभारत हायस्कूल11",
    "standard": "SSC परीक्षा 2025 दिली आहे",
    "parentName": "अनिल देश",
    "address": "कोपूर, महाराष्ट्र",
    "mobile": 9765433333,
    "email": "swati.deshmukh@e.com"
}

update student = http://192.168.29.113:8080/student/updateStudent/:id

delete student = http://192.168.29.113:8080/student/deleteStudent/:id

login  = http://192.168.29.113:8080/auth/login

    {
      
        "userId": "admin",
        "userPassword": "admin123"
    }

    download excel file= http://192.168.29.113:8080/student/downloadExcel

    registration.manoranjanmandal.in

    https://regapi.manoranjanmandal.in/

    send mail api = http://192.168.29.113:8080/student/sendMail/:id
    post method

    disabled={emailSentIds.includes(row.id)}
    style={{
        padding: '5px 10px',
        backgroundColor: emailSentIds.includes(row.id) ? 'gray' : '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: emailSentIds.includes(row.id) ? 'not-allowed' : 'pointer',
      }}
*/